// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__qyYTP","title":"Images90_title__2m5B0","images":"Images90_images__1wHET"};